import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en';
import ar from './ar';
import { getCookie } from '../utils/cookies';
import { useConfig } from '../Hooks/useConfig';

const { baseDomain } = useConfig();
const resources = {
  en: {
    translation: en,
  },
  ar: {
    translation: ar,
  },
};

const lng =
  getCookie('lng', baseDomain) ||
  (['en'].includes(navigator.language) ? navigator.language : 'en') ||
  'en';

i18n.use(initReactI18next).init({
  lng,
  debug: false,
  resources,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
